<template>
<div>
  <div class="form-group form-group-default required form-multiselect"
       :class="{ 'form-group-ie': isIE }">
    <universal-multiselect :label="$t('models.user.occupations')"
                           fieldLabel="name"
                           fieldTrackBy="id"
                           :initialValues="user.occupations"
                           :availableValues="availableOccupations"
                           :placeholder="$t('multiselect.placeholder')"
                           validationRules="required"
                           :validationName="fieldName"
                           :validationTranslation="$t('models.user.occupations')"
                           @change="onChange($event)" />
  </div>

  <transition v-if="!isManager" name="slide-fade">
    <label v-show="errors.has(fieldName)"
           id="occupations-error"
           class="error"
           :for="fieldName">
      {{ errors.first(fieldName) }}
    </label>
  </transition>
</div>
</template>

<script>
import UniversalMultiselect from '@/components/form/UniversalMultiselect'

const { detect } = require('detect-browser');

export default {
  name: 'OccupationsField',
  inject: ['$validator'],
  props: {
    availableOccupations: Array,
    isManager: Boolean,
    user: Object,
    fieldNameAddition: { type: [String, Number], default: null },
  },
  components: {
    UniversalMultiselect
  },
  methods: {
    onChange(values) {
      this.$emit('change', values)
    }
  },
  computed: {
    isIE() {
      if (detect()) {
        return detect().name == "ie"
      }
    },
    fieldName() {
      return this.fieldNameAddition ? `occupations_${this.fieldNameAddition}` : 'occupations';
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/users/form/OccupationsField.vue